<template>
  <v-select
    v-model="internalValue"
    :items="gateways"
    :loading="loading || localLoading"
    :multiple="multiple"
    :clearable="clearable"
    :label="label"
    :disabled="disabled"
    item-value="id"
    item-text="name"
    box
    flat
    success
    hide-details
    class="text-details-none"
  >
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0" class="mr-1">
        {{ item.name }}
      </span>

      <span v-if="index === 1" class="grey--text caption">
        (+{{ internalValue.length - 1 }}
        {{ internalValue.length === 2 ? "outro" : "outros" }})
      </span>
    </template>
  </v-select>
</template>

<script>
import gatewaysService from "@/services/gateways";

export default {
  name: "SelectGateways",
  props: {
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "Gateway",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      gateways: [],
      localLoading: false,
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  async created() {
    await this.fetchGateways();
  },
  methods: {
    async fetchGateways() {
      this.localLoading = true;
      try {
        const response = await gatewaysService.gateways();

        if (response && response.objects) {
          this.gateways = response.objects.map((item) => ({
            id: item.id,
            name: item.name,
          }));
        }
      } catch (error) {
        console.error("Erro ao buscar gateways:", error);
      } finally {
        this.localLoading = false;
      }
    },
  },
};
</script>
